import { NumberInput } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function MeasurementInput({
  form,
  attrib,
  value,
  error,
  ...props
}) {
  const { t } = useTranslation("pim");
  const precision =
    attrib.typeParameters.find((p) => p.name === "PRECISION")?.value ?? 0;
  const unit =
    attrib.typeParameters.find((p) => p.name === "UNIT")?.value ?? "";

  let suffix;
  switch (unit) {
    case "KILOGRAM":
      suffix = "kg";
      break;
    case "GRAM":
      suffix = "g";
      break;
    case "METER":
      suffix = "m";
      break;
    case "CENTIMETER":
      suffix = "cm";
      break;
    case "MILLIMETER":
      suffix = "mm";
      break;
    case "LITER":
      suffix = "L";
      break;
    case "MILLILITER":
      suffix = "mL";
      break;
    case "PIECE":
      suffix = t("input.unitPieces");
      break;
    case "SQUARE_METER":
      suffix = "m²";
      break;
    case "CUBIC_METER":
      suffix = "m³";
      break;
    default:
      suffix = unit;
  }

  return (
    <NumberInput
      suffix={" " + suffix}
      decimalScale={precision}
      value={value}
      onChange={(nextValue) => {
        form.setFieldValue(attrib.code, nextValue);
      }}
      error={error}
      {...props}
    />
  );
}
